import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { api, apiErr } from "@/lib/api";
import { AtSign, ArrowLeft, MailCheck } from "lucide-react";
import Footer from "@/components/Footer";

export default function ForgotPassword() {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);
  const [warn, setWarn] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setWarn("");
    try {
      await api.post("/auth/forgot-password", { email });
      setSent(true);
    } catch (e) {
      setWarn(apiErr(e));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex flex-col bg-slate-50">
      <div className="flex-1 flex items-center justify-center px-4">
        <div className="w-full max-w-md bg-white border border-slate-200 rounded-xl shadow-sm p-8">
          <button
            onClick={() => navigate("/login")}
            className="text-xs text-slate-500 hover:text-slate-800 inline-flex items-center gap-1"
            data-testid="forgot-back-btn"
          >
            <ArrowLeft size={12} /> Torna al login
          </button>

          <div className="mt-4">
            <div className="text-xs uppercase tracking-widest text-emerald-700 font-semibold">Recupero accesso</div>
            <h1 className="text-2xl font-bold text-slate-900 mt-1" style={{ fontFamily: "Manrope" }}>Password dimenticata</h1>
            <p className="text-sm text-slate-500 mt-1">
              Inserisci l'email dell'account. Ti invieremo un link temporaneo per reimpostare la password (validità 30 min).
            </p>
          </div>

          {!sent ? (
            <form onSubmit={submit} className="mt-6 space-y-4" data-testid="forgot-password-form">
              <div>
                <Label className="text-xs uppercase tracking-widest text-slate-500">Email</Label>
                <div className="relative mt-1">
                  <AtSign size={14} className="absolute left-3 top-3 text-slate-400" />
                  <Input
                    type="email"
                    required
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    className="pl-9 h-11"
                    placeholder="nome@studio.it"
                    data-testid="forgot-email-input"
                  />
                </div>
              </div>

              <Button type="submit" disabled={loading}
                      className="w-full h-11 bg-emerald-800 hover:bg-emerald-700 text-white"
                      data-testid="forgot-submit-btn">
                {loading ? "Invio in corso…" : "Invia link di reset"}
              </Button>

              {warn && (
                <div className="text-xs text-amber-800 bg-amber-50 border border-amber-200 rounded-md px-3 py-2">
                  {warn}
                </div>
              )}
            </form>
          ) : (
            <div className="mt-6 space-y-4" data-testid="forgot-sent-panel">
              <div className="border border-emerald-200 bg-emerald-50/60 rounded-md p-4 text-center">
                <MailCheck size={32} className="mx-auto text-emerald-700" />
                <div className="text-sm font-semibold text-emerald-900 mt-2">Se l'email è registrata, riceverai un link</div>
                <div className="text-xs text-slate-600 mt-1">
                  Controlla la casella e clicca sul pulsante nell'email. Il link scade in 30 minuti.
                </div>
              </div>
              {warn && (
                <div className="text-xs text-amber-800 bg-amber-50 border border-amber-200 rounded-md px-3 py-2">
                  {warn}
                </div>
              )}
              <Button variant="outline" onClick={() => navigate("/login")} className="w-full h-10">
                Torna al login
              </Button>
            </div>
          )}
        </div>
      </div>
      <Footer />
    </div>
  );
}
